module.exports = __webpack_public_path__ + "static/media/icon_money.a3c27dc6.png";